import FormattedValue from './FormattedValue';

export default FormattedValue;
